export function extractExpiryTime(accessToken: string) {
  if (!accessToken) {
    return 0;
  }
  const meta = Buffer.from(accessToken.split(".")[1], "base64");
  const payload = JSON.parse(meta.toString("utf8")) as { exp?: number };
  return (payload.exp ?? 0) * 1000;
}
